import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';
import { RdStationService, RD_STATION_AUTH_MESSAGE, RD_STATION_STATE_KEY } from '../services/RdStationService';
import { useCelular } from '../hooks/useCelular';
import './GoogleCalendarCallbackPage.css';

/** Onde a RD devolve o popup de autorização. Mesmo molde dos callbacks da Meta. */
const RdStationCallbackPage: React.FC = () => {
    const celular = useCelular();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Conectando sua conta do RD Station...');

    useEffect(() => {
        const avisarAbridor = (success: boolean, mensagem?: string) =>
            window.opener?.postMessage({ type: RD_STATION_AUTH_MESSAGE, success, mensagem }, window.location.origin);

        const run = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const state = params.get('state');

            const esperado = sessionStorage.getItem(RD_STATION_STATE_KEY);
            sessionStorage.removeItem(RD_STATION_STATE_KEY);

            try {
                if (!code) {
                    setStatus('error');
                    setMessage('A conexão com o RD Station foi cancelada ou falhou.');
                    avisarAbridor(false);
                    return;
                }
                if (!state || !esperado || state !== esperado) {
                    setStatus('error');
                    setMessage('Requisição de conexão inválida. Tente novamente pela tela Apps.');
                    avisarAbridor(false);
                    return;
                }

                const r = await RdStationService.conectar(code);
                setStatus(r.sucesso ? 'success' : 'error');
                setMessage(r.mensagem || (r.sucesso ? 'RD Station conectado.' : 'Não foi possível conectar o RD Station.'));
                avisarAbridor(r.sucesso, r.mensagem);
            } finally {
                setTimeout(() => window.close(), 1800);
            }
        };

        run();
    }, []);

    return (
        <div className="google-callback-container">
            <div className="google-callback-card">
                {status === 'loading' && <FaSpinner className="spin google-callback-icon" />}
                {status === 'success' && <FaCheckCircle className="google-callback-icon success" />}
                {status === 'error' && <FaTimesCircle className="google-callback-icon error" />}
                <p>{message}</p>
                {/* Janela aberta pelo app fecha sozinha; aba solta ou app instalado no celular
                    não fecha, então a pessoa precisa de um caminho de volta. */}
                {celular && !window.opener ? (
                    status !== 'loading' && <a className="google-callback-voltar" href="/">Voltar ao app</a>
                ) : (
                    <span className="google-callback-hint">Esta janela será fechada automaticamente.</span>
                )}
            </div>
        </div>
    );
};

export default RdStationCallbackPage;
